import { useSnapshot } from "valtio";
import { state } from "../store";
import "./AccentColorsPanel.css";

export default function AccentColorsPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "accent-colors";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define accent-specific color presets
  const accentColors = [
    // Whites and Light Colors
    {
      name: "Pearl White",
      color: "#f8fafc",
    },
    {
      name: "Light Blue",
      color: "#b9d2fc",
    },
    {
      name: "Sky Blue",
      color: "#e3edfd",
    },

    // Blues
    {
      name: "Electric Blue",
      color: "#454a4d",
    },
    {
      name: "Ocean Blue",
      color: "#0d7c9f",
    },
    {
      name: "Deep Blue",
      color: "#9eadc8",
    },

    // Purples
    {
      name: "Deep Purple",
      color: "#882f54",
    },

    // Greens
    {
      name: "Racing Green",
      color: "#117d60",
    },

    // Oranges and Reds
    {
      name: "Sunset Orange",
      color: "#ba3009",
    },

    // Dark Colors
    {
      name: "Carbon Black",
      color: "#1f2937",
    },
  ];

  const applyAccentColor = (colorPreset) => {
    // Store accent-specific color for TrimBlue material ONLY
    state.accentColor = colorPreset.color;

    // Do NOT update waterColor - keep accent color independent
    // Do NOT close panel automatically - let user close manually
  };

  // Helper function to adjust brightness of a color
  const adjustBrightness = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return "#" + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title">ACCENT COLORS</h2>
          <div className="accent-colors-wrapper">
            <div className="accent-colors-panel">
              <div className="accent-colors-grid">
                {accentColors.map((colorPreset, index) => (
                  <div key={index} className="accent-color-item" onClick={() => applyAccentColor(colorPreset)}>
                    <div
                      className="accent-color-swatch"
                      style={{
                        "--color": colorPreset.color,
                        "--color-light": adjustBrightness(colorPreset.color, 30),
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button className="close-button-accent-colors" onClick={handleClose}>
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
